// Vendor
import { Injectable } from "@angular/core";

// App
import { IsEnabled, IsSupported, OrderGetterSetter } from "./storage-service";
import { Order } from "../order/order";

@Injectable({
    providedIn: "root",
})
export class OrderSessionStorageService
    implements IsEnabled, IsSupported, OrderGetterSetter {
    private NAMESPACE_ROOT = "KARWEI.deuren-inmeetservice";
    private KEY_ENABLED = `${this.NAMESPACE_ROOT}.enabled`;
    private KEY_ORDER = `${this.NAMESPACE_ROOT}.order`;
    private orderStore_: Order;

    public get isSupported() {
        return "sessionStorage" in window;
    }

    public get isEnabled() {
        const isEnabled = this.isSupported && this.get(this.KEY_ENABLED);
        return Boolean(isEnabled).valueOf();
    }

    private serialize<T>(jsonData: T): string {
        return JSON.stringify(jsonData);
    }

    private deserialize<T>(rawData: string = "{}"): T {
        return JSON.parse(rawData);
    }

    private get<T>(key: string): T {
        const data = window.sessionStorage.getItem(key);
        const json = this.deserialize<T>(data);
        return json;
    }

    private set<T>(key: string, jsonData: T): void {
        const item = this.serialize<T>(jsonData);
        window.sessionStorage.setItem(key, item);
    }

    public get order(): Order {
        if (!this.orderStore_) {
            this.orderStore_ = this.get<Order>(this.KEY_ORDER);
        }
        return this.orderStore_;
    }

    public set order(order: Order) {
        this.set<Order>(this.KEY_ORDER, order);
    }
}
